module.exports = __webpack_public_path__ + "static/media/City Life - DK Grey_LT Grey.ead51066.jpg";